import { createPinia, setActivePinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import type { App } from 'vue';

const store = createPinia();
store.use(piniaPluginPersistedstate);

// 设置活动的 Pinia 实例
setActivePinia(store);

export const setupStore = (app: App<Element>) => {
  app.use(store);
};

export { store };
